import { useMemo } from 'react';

const useValidRole = (profile, needRole) => {
  const { data: { roles = [] } } = profile;
  const isValidRole = useMemo(() => Array.isArray(needRole) ? needRole.some(nr => roles.includes(nr)) : roles.includes(needRole), [roles]);

  return { isValidRole }
}

export default useValidRole;